//@ts-check
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils.js';

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/90',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        outline: 'border border-input bg-white hover:bg-accent hover:text-accent-foreground',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

/**
 * Primary button primitive (shadcn-style).
 * @param {import('react').ButtonHTMLAttributes<HTMLButtonElement> & {
 *   className?: string,
 *   variant?: 'default'|'secondary'|'outline'|'destructive'|'ghost'|'link',
 *   size?: 'default'|'sm'|'lg'|'icon',
 * }} props
 * @returns {import('react').ReactElement}
 */
export function Button({ className, variant, size, children, type = 'button', ...props }) {
  return (
    <button className={cn(buttonVariants({ variant, size, className }))} type={type} {...props}>
      {children}
    </button>
  );
}

export { buttonVariants };
